export const moneyFragment = `
	fragment Money on MoneyV2 {
		amount
		currencyCode
	}
`;
